import { useMutation, useQueryClient } from "@tanstack/react-query";

import { updateFarmDetails } from "services";

import { GET_FARMS, GET_FARM_DETAILS, UPDATE_FARM_DETAILS } from "consts";

export const useUpdateFarmDetails = ({ farmId }: { farmId: string }) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationKey: [UPDATE_FARM_DETAILS, farmId],
    mutationFn: updateFarmDetails,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [GET_FARMS] });
      queryClient.invalidateQueries({ queryKey: [GET_FARM_DETAILS, farmId] });
    },
  });
};
